module.exports = __webpack_public_path__ + "img/Dantam Bridal 28.e54a80c3.jpg";